import { useDetailListSubmit, useSearchFilterRef } from '@/hooks';
import { cn } from '@/utils';
import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export type HyperLinkProps = {
	children: React.ReactNode;
	params?: {
		pathname: string;
		id?: string | number;
		query?: any;
	};
	className?: string;
	hidden?: boolean;
	callback?: () => void;
};
const HyperLink = ({
	children,
	className,
	params,
	hidden,
	callback,
}: HyperLinkProps) => {
	const navigate = useNavigate();
	const { pathname, id, query } = params || {};

	const searchFilterRef = useSearchFilterRef({
		onSearchChange: () => {
			callback?.();
		},
	});

	const { onDetailSubmit } = useDetailListSubmit({
		toDetailPathName: pathname || '',
		searchFilterRef: searchFilterRef,
	});

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLDivElement>) => {
			e.stopPropagation();
			if (!id && !pathname) return;
			if (pathname && !id) {
				navigate(pathname);
				return;
			}

			onDetailSubmit?.(id as string | number, undefined, query);
		},
		[id, pathname, query]
	);

	return (
		<div
			className={cn(
				'text-blue2 underline cursor-pointer text-[13px] hover:text-blue3',
				className
			)}
			onClick={handleClick}
		>
			{children}
		</div>
	);
};

export default memo(HyperLink);
